import { Card, CardActions, CardContent, makeStyles } from "@material-ui/core";
import Button from "../Button/LyfeButton";
import Typography from "../Typography/Typography";

const useStyles = makeStyles({
	root: {
		minWidth: "17.188rem",
		width: "19.125rem",
		height: "13.75rem",
		margin: "1rem 0.125rem 3.75rem 0",
		padding: "1.5rem 1.438rem 1.5rem 1.5rem",
		borderRadius: "0.25rem",
		boxShadow: "0 0 0.5rem 0 rgba(0, 0, 0, 0.08)",
		backgroundColor: "white",
		"&:hover": {
			boxShadow: "0 0.375rem 0.625rem 0 rgba(0, 0, 0, 0.08)",
		},
	},
	cardContent: {
		padding: 0,
	},
	cardTitle: {
		width: "6.25rem",
		height: "2.063rem",
		flexGrow: 0,
		margin: "0 9.875rem 0.5rem 0",
		textAlign: "left",
	},
	line: {
		fontSize: "1.125rem",
		color: "#0b5a65",
		textTransform: "uppercase",
		position: "relative",
		display: "inline-block",
		"&:after": {
			content: "",
			position: "absolute",
			top: "50%",
			width: "100rem",
			height: "0.031rem",
			background: "#0b5a65",
			marginLeft: "0.688rem",
		},
	},
});

interface ILyfeCardProps {
	title: string;
	content?: string;
	ctaText?: string;
	onClickReadMore?: () => void;
	children?: any;
}

const LyfeCard = (props: ILyfeCardProps) => {
	const { title, content, ctaText, onClickReadMore } = props;
	const classes = useStyles();

	if (props.children) {
		return (
			<Card className={classes.root}>
				<CardContent className={classes.cardContent}>
					<div>
						<span className={classes.line}>{title}</span>
					</div>
					{props.children}
				</CardContent>
			</Card>
		);
	}

	return (
		<Card className={classes.root}>
			<CardContent className={classes.cardContent}>
				<Typography type="h2" className={classes.cardTitle} style={{ color: "#0b5a65" }}>
					{title}
				</Typography>
				<Typography type="tableMainText" style={{ color: "#212121" }}>
					{content}
				</Typography>
			</CardContent>
			<CardActions style={{ margin: 0, padding: 0 }}>
				<Button use="read-more" onClick={onClickReadMore} style={{ paddingLeft: 0, marginTop: "1.5rem" }} color="primary">
					{ctaText}
				</Button>
			</CardActions>
		</Card>
	);
};

export default LyfeCard;
